<template>
  <div class="sidebar" :class="{ opened: nav_opened }">
    <div class="sidebar__fader" @click="nav_opened = false"></div>
    <div class="sidebar__body">
      <div class="sidebar__header">
        <logo variant="light" />
        <div class="text"><strong>CRM</strong> випускників</div>
      </div>
      <div class="sidebar__menu">
        <ul>
          <li>
            <router-link :to="{ name: 'funnels' }">
              <span class="icon"><b-icon icon="filter"></b-icon></span
              ><span class="text">Воронки</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'admin-users' }">
              <span class="icon"><b-icon icon="people-fill"></b-icon></span
              ><span class="text">Випускники</span>
            </router-link>
          </li>

          <li>
            <router-link :to="{ name: 'admin-tests' }">
              <span class="icon"><b-icon icon="clipboard-check"></b-icon></span
              ><span class="text">Тести</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'admin-tags' }">
              <span class="icon"><b-icon icon="tag-fill"></b-icon></span
              ><span class="text">Теги та категорії</span>
            </router-link>
          </li>

          <li class="separator"></li>
          <li>
            <router-link :to="{ name: 'admin-administrators' }">
              <span class="icon"><b-icon icon="gear-fill"></b-icon></span
              ><span class="text">Адміністратори</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/components/header-logo.vue";
export default {
  components: {
    logo,
  },
  data() {
    return {
      nav_opened: false,
    };
  },
  watch: {
    $route: {
      handler() {
        this.nav_opened = false;
      },
    },
  },
  mounted() {
    window.addEventListener("openNav", () => {
      this.nav_opened = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  min-width: 100%;
  height: 100vh;
  max-height: 100vh;
  position: fixed;
  width: var(--admin-sidebar-width);
  min-width: var(--admin-sidebar-width);
  left: 0;
  top: 0;
  bottom: 0;
  transition: 0.3s;
  z-index: 200;
  @media (max-width: 991px) {
    transform: translateX(-100%);
    transition: 0.3s;
    &.opened {
      transform: translateX(0%);
      transition: 0.3s;

      box-shadow: 0px 0px 20px 0px rgba(#000, 0.5);
      .sidebar__fader {
        visibility: visible;
        opacity: 1;
        transition: 0.3s;
        transition-delay: 0.2s;
      }
    }
  }
  &__fader {
    background: rgba(#000, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    visibility: hidden;
    opacity: 0;
    transition: 0s;
  }
  &__body {
    background: var(--primary-color);
    height: 100vh;
    max-height: 100vh;
    z-index: 100;
    position: relative;
  }
  &__menu {
    padding: 20px 15px 40px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        padding-bottom: 6px;
        &.separator {
          height: 1px;
          background: rgba(#fff, 0.2);
          margin: 10px 0px;
          padding: 0;
        }
        a {
          color: #fff;
          display: flex;
          align-items: center;
          border-radius: 8px;
          min-height: 42px;
          transition: 0.3s;
          padding: 3px 8px;
          box-sizing: border-box;
          text-decoration: none;
          opacity: 0.7;
          padding-left: 42px;
          position: relative;
          font-size: 16px;
          &.router-link-exact-active,
          &.router-link-active {
            opacity: 1;
            background: rgba(#fff, 0.2);
          }
          .text {
            padding-left: 12px;
          }
          .icon {
            width: 36px;
            height: 36px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 8px;
            svg {
              height: 1.2em;
              width: 1.2em;
            }
          }
          &:hover {
            opacity: 1;
            transition: 0.3s;
          }
        }
      }
    }
  }
  &__header {
    padding: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      height: 48px;
    }
    .text {
      margin-left: 20px;
      line-height: 1;
      font-weight: 300;
      strong {
        display: block;
        font-weight: strong;
        font-size: 22px;
        opacity: 0.7;
      }
    }
  }
}
</style>
